import React from 'react';
import { FormattedMessage } from 'react-intl';
import { map } from 'lodash';
import logo from '../assets/images/logooecd_en.png';
import { Link } from './visions/vx-link';

const Menu = ({ availableLocales, locale, changeLocale }) => (
  <div className="menu">
    {
      map(availableLocales, (l, key) => {
        if (key == locale) return <span key={key}>{l.label}</span>;
        return <a key={key} onClick={() => changeLocale(key)}>{l.label}</a>;
      })
    }
  </div>
);

const Header = (props) => (
  <header className="notranslate">
    <div className="container">
      <div className="row">
        <div className="col-sm-4 col-xs-6">
          <Link to="/">
            <img src={logo} alt="" className="logo"/>
          </Link>
        </div>
        <div className="col-sm-8 small text-muted hidden-xs">
          <div className="mini-admin text-right">
            <Link to="rss-feed">
              RSS
            </Link>
            <Link to="admin">
              Administration
            </Link>
            <Menu {...props} />
          </div>
          <p>
            <FormattedMessage id="header.top"/>
          </p>
          <p>
            <FormattedMessage id="header.bottom"/>
          </p>
        </div>
        <div className="col-xs-6 visible-xs text-right">
          <div className="p25-0">
            <Menu {...props} />
          </div>
        </div>
      </div>
    </div>
  </header>
);

export default Header;


// WEBPACK FOOTER //
// ./src/views/header.js